import { dba, HasSelect } from "app/common/utilities/db"
import db, { Prisma } from "db"

export function findArticles<T extends Prisma.ArticleFindManyArgs & HasSelect>(
  args?: Prisma.SelectSubset<T, Prisma.ArticleFindManyArgs>
) {
  return dba<Prisma.ArticleGetPayload<T, keyof T>[]>(() => db.article.findMany(args))
}
